import { render, staticRenderFns } from "./InsuredForm.vue?vue&type=template&id=62c3a85c&scoped=true&"
import script from "./InsuredForm.vue?vue&type=script&lang=ts&"
export * from "./InsuredForm.vue?vue&type=script&lang=ts&"
import style0 from "./InsuredForm.vue?vue&type=style&index=0&id=62c3a85c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c3a85c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
